import type { InterventionAssignFormProps } from "./intervention-assign-form.type";
import type { ModelAssignFormValues } from "@/modules/model-assign";

import { useInterventionAssign } from "@/entities/intervention";

export const useInterventionAssignForm = ({
  intervention,
  options,
}: InterventionAssignFormProps) => {
  const { mutate, status, error } = useInterventionAssign(
    intervention.id,
    options
  );

  const onFormSubmit = (values: ModelAssignFormValues) => {
    const users = values.users.map((user) => user.value);
    return mutate(users);
  };

  return {
    onFormSubmit,
    status,
    error,
  };
};
